/* hero-20260908-v1: one timer per connected carousel, no DOM observers. */
if (!customElements.get('handart-slideshow')) {
  customElements.define('handart-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.pauseButton = this.querySelector('[data-pause]');
      if (this.slides.length < 2) return;
      this.querySelector('.han-slideshow__controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), {signal});
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i), {signal}));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, {signal});
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1)); }
      }, {signal});
      this.addEventListener('touchstart', e => { this.startX = e.changedTouches[0].clientX; this.startY = e.changedTouches[0].clientY; }, {signal, passive:true});
      this.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - this.startX;
        const dy = e.changedTouches[0].clientY - this.startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
      }, {signal, passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => this.schedule(), {signal});
      document.addEventListener('shopify:block:select', e => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
        if (i >= 0) { this.paused = true; this.show(i); }
      }, {signal});
      this.show(0);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        this.dots[i].setAttribute('aria-pressed', String(active));
      });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.motion.matches;
      this.pauseButton.setAttribute('aria-label', stopped ? 'Play slideshow' : 'Pause slideshow');
      this.pauseButton.querySelector('span').textContent = stopped ? '▷' : 'Ⅱ';
      if (!stopped && !document.hidden && this.isConnected) {
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 2000);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
